<script setup lang="ts">
import type { SinglePlayer, SomePlayer } from '~/store/localGameStore'

defineProps<{
  player: SomePlayer
  players: SinglePlayer[]
  playerOnThrow: SinglePlayer | null
  remainingScore: number
  showAverage: boolean
  isOnThrow: boolean
  legAverage: number | null
  legsWon: number
  isRightPlayer: boolean
  legsToWin: number | null
  legsToPlay: number | null
}>()
</script>

<template>
  <div
    class="flex flex-col bg-gray-100 dark:bg-gray-800"
    :class="{ 'bg-primary/40 dark:bg-primary': isOnThrow }"
  >
    <div class="flex flex-col p-1 px-2 max-w-full">
      <div class="w-full pb-1">
        <div
          v-for="teamPlayer in players"
          :key="teamPlayer.id"
          :class="{ 'font-bold !opacity-100 !text-4xl sm:!text-5xl lg:!text-6xl xl:!text-6xl': teamPlayer.id === playerOnThrow?.id, 'justify-end': isRightPlayer }"
          class="flex items-center gap-1 opacity-40 truncate overflow-hidden flex-row !flex-nowrap max-w-full !text-2xl sm:!text-3xl lg:!text-4xl xl:!text-4xl"
        >
          <div class="truncate">
            {{ teamPlayer.name }}
          </div>
        </div>
      </div>
      <div class="flex flex-row justify-between flex-wrap">
        <div class="flex flex-col w-full">
          <div
            class="flex flex-row gap-1 flex-wrap items-center"
            :class="{ 'justify-end': isRightPlayer }"
          >
            <template v-if="legsToWin">
              <Icon
                v-for="leg in legsToWin"
                :key="`${leg}-player-`"
                :name="legsWon >= leg ? 'tabler-checkbox' : 'tabler-square'"
                class="!size-8 sm:!size-10 md:!size-12 lg:!size-14 flex items-center justify-center"
              />
            </template>
            <template v-else>
              <span class="text-xl">
                {{ $t('Legs:') }}
              </span>
              <Icon
                v-for="leg in legsWon"
                :key="`${leg}-player-`"
                name="tabler-checkbox"
                class="!size-8 sm:!size-10 md:!size-12 lg:!size-14 flex items-center justify-center"
              />
            </template>
          </div>
          <div
            v-if="showAverage"
            class="text-base md:text-xl"
            :class="{ 'text-right': isRightPlayer, 'text-left': !isRightPlayer }"
          >
            Leg Avg: {{ legAverage }}
          </div>
        </div>
        <div
          class="md:text-8xl lg:text-9xl full text-6xl font-bold w-full"
          :class="{ 'text-right': isRightPlayer, 'text-left': !isRightPlayer }"
        >
          {{ remainingScore }}
        </div>
      </div>
    </div>
  </div>
</template>
